import { Icon } from '@iconify/react/dist/iconify.js';

const Instructions = () => {
    return (
        <div className="col-xxl-7 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="card h-100">
                <div className="card-body">
                    <h6 className="text-lg mb-3 fw-semibold">How It Works?</h6>

                    <ul className="list-unstyled mb-0">
                        {/* Step 1 */}
                        <li className="d-flex align-items-start gap-2 mb-2">
                            <Icon icon="solar:link-circle-bold" className="text-primary mt-1" />
                            <span>Copy your unique referral link or code.</span>
                        </li>

                        {/* Step 2 */}
                        <li className="d-flex align-items-start gap-2 mb-2">
                            <Icon icon="mdi:share-variant" className="text-success mt-1" />
                            <span>Share it with friends via WhatsApp, email, or social media.</span>
                        </li>

                        {/* Step 3 */}
                        <li className="d-flex align-items-start gap-2 mb-2">
                            <Icon icon="mdi:account-plus" className="text-warning mt-1" />
                            <span>
                                Your friend signs up and enters the referral code within <strong>7 days</strong>.
                            </span>
                        </li>

                        {/* Step 4 */}
                        <li className="d-flex align-items-start gap-2 mb-2">
                            <Icon icon="mdi:credit-card-outline" className="text-info mt-1" />
                            <span>
                                They purchase any premium plan — <strong>Starter, Professional, or Agency</strong>.
                            </span>
                        </li>

                        {/* Step 5 */}
                        <li className="d-flex align-items-start gap-2 mb-2">
                            <Icon icon="mdi:gift-outline" className="text-danger mt-1" />
                            <span>
                                You get <strong>1 month FREE premium</strong> as a reward 🎉
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Instructions;